import Axios from 'axios'
import { relevant } from '../common/util'


export default {
    brand: "CHU",
    project: "strata",
    projectTitle: "Strata",
    documentTitle: "Get a Quote | Residential Strata Insurance",
    paymentSuccessRedirect: "http://www.chu.com.au/",
    icon: require("./images/favicon.ico"),
    environment: process.env.REACT_APP_ENVIRONMENT,
    axios: Axios.create(),

    endpoints:{
        quoteSetup:         `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/quotesetup/v1`,
        flatQuote:          `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/flatquote/v1`,
        finalise:           `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/finalise/v1`,
        
        template:            `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/details/v1`,

        email:              `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/documents/v1`,
        payOffline:         `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/documents/v1`,
        paymentAuthorise:   `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/authorise/v1`,
        paymentInitiate:    `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/initiate/v1`,
        payInstalments:     `${process.env.REACT_APP_INSTALMENTS_PATH}`,
        payInstalmentsMPF:  `${process.env.REACT_APP_INSTALMENTS_PATH_MPF}`,
        saveAndExit:        `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/quotesaveandexit/v1`,
        findToken:          `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/findtoken/v1`,
        restore:            `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/details/v1`,

        options:            `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/options/v1`,
        excesses:           `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/excesses/v1`,
        limits:             `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/limits/v1`,
        sumsinsured:        `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/sumsinsured/v1`,
        paymentOptions:     `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/paymentOptions/v1`,
        validateAddress:    `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHURESI_PATH}/validateaddress/v1`,

        suburbAutoComplete: `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_POSTCODE_PATH}`,
        postcodeAutoComplete:`${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_SMART_ADDRESS_PATH}`,
    },


    // RESTORE
    restore:{
        transformer: fields => fields,
        fieldNames:{ 
            quoteNumber: "quoteNumber",
            email: "requester.email"
        }
    },

    // PROGRESS
    progressGroups: [{
        "/step-1": "Step 1",
        "/step-2": "Step 2",
        "/step-3": "Step 3",
        "/step-4": "Step 4",
        "/step-5": "Step 5",
        "/step-6": "Premium Summary"
    }],

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/strata/config.ts